import React, { Component } from 'react';

//higher order component to wrap components with auth info
//see https://reactjs.org/docs/higher-order-components.html

function authWrapper(auth) {
  return WrappedComponent => {
    class AuthWrapper extends Component {
      constructor(props) {
        super(props);
        this.state = {
          isAuthenticated: false,
          isAuthorized: false,
          isLoadingUserData: false,
          loginError: null,
          userData: null,
        };
      }

      componentDidMount() {
        this._checkAuth();
      }

      _checkAuth() {
        //check if authenticated
        auth
          .isAuthenticated()
          .then(isAuthenticated => {
            this.setState({
              isAuthenticated,
              isLoadingUserData: true,
            });
            //if authenticated, check authorized, else not authorized
            return isAuthenticated
              ? auth.isAuthorized()
              : new Promise(resolve => resolve(false));
          })
          .then(isAuthorized => {
            this.setState({ isAuthorized });
            //if authorized, get user data, else set to null
            return isAuthorized
              ? auth.getUserData()
              : new Promise(resolve => resolve(null));
          })
          .then(userData => {
            this.setState({
              userData,
              isLoadingUserData: false,
            });
          })
          .catch(loginError => {
            //store all errors
            console.error(loginError);
            this.setState({ loginError });
          });
      }

      render() {
        //pass the state as props to the wrapped component
        return <WrappedComponent {...this.state} />;
      }
    }

    return AuthWrapper;
  };
}

export default authWrapper;
